import {Component, Input, OnInit} from '@angular/core';
import {OrderItem} from '../../back-office/Models/OrderItem';
import {OrderItemProduct} from '../../back-office/Models/OrderItemProduct';

@Component({
  selector: 'app-summary-box',
  templateUrl: './summary-box.component.html',
  styleUrls: ['./summary-box.component.scss']
})
export class SummaryBoxComponent implements OnInit {
  @Input() orderItem: OrderItem;
  @Input() orderItemProduct: OrderItemProduct;
  @Input() customerPrice;
  constructor() { }

  ngOnInit() {
  }

}
